// src/icons/Satoshi.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Satoshi({
  strokeWidth = "3.71429",
  strokeLinecap = "butt"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 26 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M0 11.2142H26",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M13 5.64284V0.0714111",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M13 40.9286V35.3572",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M0 20.5H26",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M0 29.7858H26",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        )
      ]
    }
  );
}

export {
  Satoshi
};
